import { enUS } from './enUS';
import { esES } from './esES';
import { ptBR } from './ptBR';

export const resources = {
	en: enUS,
	es: esES,
	ptBr: ptBR
};
